import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { store as reduxStore } from 'reactApp/store';
import { renderCopyDialog } from 'reactApp/ui/SelectFolderDialog/SelectFolderDialog.toolkit';

import { getSelectedItemsOrCurrentFolder } from './helpers/getSelectedItemsOrCurrentFolder';

export const copy = (id?: string, sendAnalytics?: (data?: any) => void): void => {
    const state = reduxStore.getState();
    const currentStorage = getCurrentStorage(state);
    const items = getSelectedItemsOrCurrentFolder(id);

    if (!items?.length) {
        return;
    }

    const onSuccess = () => {
        sendAnalytics?.({
            action: 'copy',
            source: currentStorage,
            count_files: items.length,
            items,
        });
    };

    renderCopyDialog({ items, onSuccess });
};
